import { SearchMemberListOptions } from '../../../../constants/Options';
import SelectInputBox from '../../../../constants/SelectInputBox';
import { useFormik } from 'formik';

const MemberSearchView = ({ setOnSearchMem, refetch, member_data, setMemberSN }: any) => {

    const handleSelect = (item: string) => {
        setOnSearchMem(item);
    };

    const searchMemberListOptions = SearchMemberListOptions(member_data?.results);

    const formik = useFormik({
        initialValues: {
            member_sn: "",
        },
        onSubmit: async (values) => {
        },
    });

    const handleSelectBox = async (name: string, selectedOption: any) => {
        const value = selectedOption?.value || "";
        await formik.setFieldValue(name, value);
        setMemberSN(value);
    };


    return (
        <div>
            <SelectInputBox
                label="Member Search"
                options={searchMemberListOptions}
                optionSelect={(name: string, selectedOption: any) => {
                    handleSelectBox(name, selectedOption);
                }}
                isLoading={false}
                value={formik.values.member_sn}
                required={true}
                placeholder="Select Member List"
                name="member_sn"
                handleBlur={formik.handleBlur}
                debouncedHandleInputChange={handleSelect}
                touched={formik.touched.member_sn}
                errors={formik.errors.member_sn}
            />
        </div>
    );
};

export default MemberSearchView;